import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VeeValidate from "vee-validate";
/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";
import OTPInput from "@8bu/vue-otp-input";
/* import specific icons */
import {
  faUserSecret,
  faAngleRight,
  faAngleLeft,
  faCaretRight,
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueSweetalert2 from "vue-sweetalert2";

// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-search-select/dist/VueSearchSelect.css";
import vuetify from "./plugins/vuetify";
import "sweetalert2/dist/sweetalert2.min.css";
// Import the functions you need from the SDKs you need
// import firebase from "firebase/app";
// import firebase from "firebase/compat/app";
import "firebase/compat/messaging";
// import VueToast from "vue-toast-notification";
// import "vue-toast-notification/dist/theme-sugar.css";

// import { getAnalytics } from "firebase/analytics";

/* add icons to the library */
library.add(faUserSecret, faAngleRight, faAngleLeft, faCaretRight, faCaretDown);

/* add font awesome icon component */
Vue.component("font-awesome-icon", FontAwesomeIcon);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
const options = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674",
};

Vue.use(VueSweetalert2, options);

Vue.use(VeeValidate, {
  inject: false,
});
Vue.use(OTPInput);

Vue.config.productionTip = false;

// script firebase
// if ("serviceWorker" in navigator) {
//   firebase.initializeApp({
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTH_DOMAIN,
//     projectId: process.env.VUE_APP_PROJECT_ID,
//     storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
//     messagingSenderId: process.env.VUE_APP_MESSAGE_SENDER_ID,
//     appId: process.env.VUE_APP_APP_ID,
//     measurementId: process.env.VUE_APP_MEASUREMENT_ID,
//   });

//   navigator.serviceWorker
//     .register("firebase-messaging-sw.js", {
//       scope: "firebase-cloud-messaging-push-scope",
//     })
//     .then(() => {
//       const messaging = firebase.messaging();
//       messaging.getToken({
//         vapidKey: process.env.VUE_APP_VAPID_KEY,
//       });
//     });
// }

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
